/* ==========================================================================
   PanelAccommodation > Client > Rooms
   ========================================================================== */

/* Modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addStyle, addData, randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');

const PanelRoomTemplate = require('../../../../panel-room/template');
const PanelRoomClient = require('../../../../panel-room/client/js');
const PanelRoomsActions = require('../../../../panel-room/client/js/store/actions');

const configuration = require('../config');

function getNewRoomData(instance) {
    /* Rest  */
    const subtractToZero = (value, substract) => {
        if (value > 0 && substract > 0) {
            return subtractToZero(value - 1, substract - 1);
        }

        return { value, substract };
    };
    const { config = {}, store = {} } = instance;
    const { people = [], maxPeople } = config;
    const { totalPeople } = store.select('data');
    const totalPeopleNewRoom = people.reduce((a, b) => a + b.value, 0);
    let peopleSubstract;

    if (totalPeople + totalPeopleNewRoom > maxPeople)
        return [...people]
            .reverse()
            .map(item => {
                if (peopleSubstract === undefined) peopleSubstract = totalPeople + totalPeopleNewRoom - maxPeople;

                const { value, substract } = subtractToZero(item.value, peopleSubstract);
                peopleSubstract = substract;

                return { ...item, value };
            })
            .reverse();
    return people;
}

function addRoom(instance) {
    const { config = {}, hooks = {}, store = {} } = instance;
    const { context = {}, literals = {} } = config;
    const { roomLabel = '#number#' } = literals;

    /* Data */
    const { totalRooms = 1 } = store.select('data');

    const type = randomId(randomId(configuration().type.room));

    /* Prepare Data */
    const roomData = addStyle(
        addData(
            {
                config: {
                    hasDelete: true,
                    literals: {
                        ...literals,
                        roomLabel: roomLabel.replace('#number#', totalRooms)
                    }
                },
                people: getNewRoomData(instance)
            },
            { type }
        ),
        [configuration().css.room]
    );

    /* Add panel to dom */
    const template = PanelRoomTemplate(roomData, context);
    const node = toNode(template)[0];
    hooks.rooms.appendChild(node);

    /* Init room */
    initRoom(instance, [node]);
}

function initRooms(instance) {
    const result = instance;
    const { selector, element } = instance;

    const roomsEl = [...element.querySelectorAll(`${selector} [data-component="PanelRoom"]`)];

    initRoom(result, roomsEl);
}

function initRoom(instance, roomsEl) {
    const result = instance;
    const { rooms = [], selector, reactions = {} } = instance;

    /* Init room */
    const roomsInstances = roomsEl.map(room => {
        const { type = '' } = room.dataset;
        return PanelRoomClient(`${selector} [data-component="PanelRoom"][data-type="${type}"]`);
    });

    if (roomsEl.length > 0) {
        result.rooms = [...rooms, ...roomsInstances];

        /* Extends Reactions */
        result.reactions = {
            ...reactions,
            ...roomsInstances
                .map(room => ({
                    [`room-delete-${room.element.dataset.type}`]: room.store.subscribe((state, action) => {
                        if (action.type !== PanelRoomsActions.types.DESTROY) return;
                        /**
                         * counter reference position
                         */
                        const index = result.rooms.indexOf(room);

                        /* Dispatch action to sync in our store */
                        instance.actions.removeRoom(index);
                    }),
                    [`room-change-${room.element.dataset.type}`]: room.store.subscribe((state, action) => {
                        if (action.type !== PanelRoomsActions.types.CHANGE) return;

                        /* Dispatch update room */
                        instance.actions.updateRooms();
                    })
                }))
                .reduce((acc, val) => ({
                    ...acc,
                    ...val
                }))
        };
    }
}

function destroyRoom(instance, roomIndex) {
    if (roomIndex === 0 || !instance.rooms[roomIndex]) return;

    const panel = instance;
    const { rooms = [], reactions = {}, store = {}, config = {} } = instance;
    const { literals } = config;
    const { roomLabel = '#number#' } = literals;

    /* Data, get id of room */
    const { rooms: roomsStore } = store.select('data');
    const { id: roomId } = roomsStore[roomIndex];

    const room = rooms[roomIndex];
    const roomInit = Object.keys(room).length !== 0;

    if (room) {
        /* Unsubscribe */
        reactions[`room-delete-${roomId}`].unsubscribe();
        reactions[[`room-change-${roomId}`]].unsubscribe();

        /* Remove refereces */
        delete panel.reactions[`room-delete-${roomId}`];
        delete panel.reactions[`room-change-${roomId}`];

        panel.rooms.splice(roomIndex, 1);

        /* update content of room label */
        rooms.forEach((item, ind) => {
            const { hooks = {} } = item;

            if (ind !== 0 && hooks.label) {
                hooks.label.textContent = roomLabel.replace('#number#', ind + 1);
            }
        });

        /* Destroy room */
        if (roomInit) room.actions.destroy();
    }
}
module.exports = {
    initRooms,
    destroyRoom,
    addRoom
};
